import script from "./GroupManageIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupManageIndex.vue?vue&type=script&lang=ts&setup=true"

import "./GroupManageIndex.vue?vue&type=style&index=0&id=1902016c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1902016c"]])

export default __exports__